import {Component, Input, OnInit} from '@angular/core';
import {Pet} from '../../models/pet.model';
import {Platform} from '@ionic/angular';

@Component({
  selector: 'app-refresher',
  templateUrl: './refresher.component.html',
  styleUrls: ['./refresher.component.scss'],
})
export class RefresherComponent implements OnInit {
  @Input() refreshCallback: any;
  @Input() refPageObj: any;

  private pullingIcon: string;

  constructor(
    private platform: Platform
  ) { }

  ngOnInit() {
    this.platform.ready().then(() => {
      if (this.platform.is('ios')) {
        this.pullingIcon = 'lines';
      } else {
        this.pullingIcon = 'circular';
      }
    });
  }

  doRefresh(event) {
    this.refreshCallback(event, this.refPageObj);
    event.target.complete();
  }

}
